import {
  FinishData,
  FinishErrors,
} from "../../common-loader/hooks/useAsyncLoader";
import { Tokens } from "../../server/src/setup-proxy/miscellaneous/onProxyV1Oauth2Req";
import { getOidcClient } from "./getOidcClient";
import { processSignInResponse } from "./processSignInResponse";

export type SigninResponseProxied = Pick<
  Tokens,
  "expires_in" | "refresh_token_expires_in"
>;

export type SignInOutput = Promise<
  FinishData<SigninResponseProxied> | FinishErrors
>;

export async function signIn(): Promise<SignInOutput> {
  return getOidcClient()
    .createSigninRequest({ state: { bar: 15 } })
    .then(function (
      // eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
      req
    ) {
      // eslint-disable-next-line functional/immutable-data, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
      (window as any).location = req.url;
      return processSignInResponse();
    })
    .catch(function () {
      return {
        tag: "errors",
        errors: [],
        uuid: "407665af-2aad-4a44-b8e8-b1dca7094209",
      };
    });
}
